import apiClient from "./http";

export const generateReport = (analysisId) =>
  apiClient.post(`/Reports/${analysisId}/generate`);

export const getReport = (analysisId) => apiClient.get(`/Reports/${analysisId}`);

export const downloadReport = (analysisId) =>
  apiClient.get(`/Reports/${analysisId}/download`);
